import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSiteUrl } from "@/lib/seo";
import { buildArticleSchema, buildWebSiteSchema, injectSchemas } from "@/lib/schema";
import { pillarArticles, type ArticleLocale } from "@/mocks/articles";

type LocaleKey = "en" | "fr" | "da" | "de";

function pickLocale(
  lang: string,
  locales: { en: ArticleLocale; fr: ArticleLocale; da: ArticleLocale; de: ArticleLocale },
): ArticleLocale {
  const key = (lang.split("-")[0] || "en") as LocaleKey;
  return locales[key] ?? locales.en;
}

export default function JsonLd() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const origin = getSiteUrl();
    const lang = i18n.language.split("-")[0] || "en";
    const schemas: object[] = [];

    if (pathname === "/") {
      schemas.push(buildWebSiteSchema(lang));
    } else if (pathname === "/allchinabuy-spreadsheet-guide") {
      schemas.push(
        buildArticleSchema({
          title: t("title"),
          description: t("metaDescription"),
          url: `${origin}/allchinabuy-spreadsheet-guide`,
          lang,
        }),
      );
    } else if (pathname.startsWith("/articles/")) {
      const slug = pathname.slice("/articles/".length);
      const article = pillarArticles.find((a) => a.slug === slug);
      if (article) {
        const locale = pickLocale(i18n.language, article.locales);
        schemas.push(
          buildArticleSchema({
            title: locale.title,
            description: locale.metaDescription,
            url: `${origin}/articles/${slug}`,
            image: article.image,
            lang,
          }),
        );
      }
    }

    injectSchemas(schemas);
  }, [pathname, i18n.language, t]);

  return null;
}